import { render, staticRenderFns } from "./SpinInfo.vue?vue&type=template&id=3a47505c&scoped=true&"
import script from "./SpinInfo.vue?vue&type=script&lang=js&"
export * from "./SpinInfo.vue?vue&type=script&lang=js&"
import style0 from "./SpinInfo.vue?vue&type=style&index=0&id=3a47505c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a47505c",
  null
  
)

export default component.exports